import React from 'react';
const tomos = [{
  number: '01',
  title: 'LA ENTRADA DE IMPACTO',
  subtitle: 'Dominá los primeros 7 segundos en cualquier entorno.'
}, {
  number: '02',
  title: 'EL LENGUAJE DEL DINERO',
  subtitle: 'Micro-gestos para negociar sueldos y contratos.'
}, {
  number: '03',
  title: 'EL ESPEJO DEL LÍDER',
  subtitle: 'Proyectá una imagen de autoridad real.'
}, {
  number: '04',
  title: 'NEUTRALIZADOR DE CRÍTICOS',
  subtitle: 'Desarmá ataques y sabotajes sin confrontar.'
}, {
  number: '05',
  title: 'ORATORIA NO VERBAL',
  subtitle: 'Dominá cualquier sala con presencia corporal.'
}, {
  number: '06',
  title: 'DE REEMPLAZABLE A CLAVE',
  subtitle: 'Posicionate como indispensable.'
}];
export function BenefitsTags() {
  return <section className="py-12 px-4 bg-brand-dark" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-brand-text mb-2 text-center" data-id="element-15">
          Todo lo que incluye el sistema
        </h2>
        <p className="text-brand-muted text-sm text-center mb-8" data-id="element-16">
          6 tomos · +360 páginas · Implementación inmediata
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-8" data-id="element-17">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-black border border-brand-gold/25 rounded-lg px-4 py-3" data-id="element-18">
              <span className="text-brand-gold text-[10px] font-bold tracking-widest" data-id="element-19">
                📖 TOMO {tomo.number}
              </span>
              <h3 className="text-brand-text font-bold text-sm leading-tight mt-1" data-id="element-20">
                {tomo.title}
              </h3>
              <p className="text-brand-muted text-xs mt-1 leading-snug" data-id="element-21">
                {tomo.subtitle}
              </p>
            </div>)}
        </div>

        <p className="font-heading text-lg md:text-xl text-brand-gold italic text-center" data-id="element-22">
          "De profesional funcional a ejecutivo de élite."
        </p>
      </div>
    </section>;
}